import { combineReducers } from 'redux';
import menuReducer from './menuReducer';
import reducer from './reducer';
import customerReducer from './reducers/customers';
import profileReducer from './reducers/profile';
import equipmentReducer from './reducers/equipment';
import categoryReducer from './reducers/category';

export default combineReducers({
  menu: menuReducer,
  customers:customerReducer,
  profiles:profileReducer,
  equipment: equipmentReducer,
  category: categoryReducer,
  reducer,
});
